<script setup lang="ts">
const props = defineProps<{
    level: Dimension
    alwaysOpen?: boolean
}>()

/**
 * Use framework.
 */
const { findChildren, fetchChildren } = useFramework()

/**
 * List of children items.
 */
const children = computed(() => {
    return findChildren(props.level.id)
})

/**
 * Fetching state.
 */
const fetching = ref(false)

/**
 * Fetch the item children.
 */
async function fetch() {
    if (props.level.hasChildren) {
        fetching.value = true
        await fetchChildren(props.level.id)
        fetching.value = false
    }
}
</script>

<script lang="ts">
export default { name: 'FrameworkItem' }
</script>
        
        
<template>
    <Disclosure v-slot="{ open }" as="dd" class="flex-1">
        <slot>
            <WorldFrameworkContent :level="level" :open="open" @click="fetch" />
        </slot>

        <Transition
            enter-active-class="transition duration-200 ease-out"
            enter-from-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-200 ease-out"
            leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
        >
            <div v-if="open || alwaysOpen">
                <DisclosurePanel
                    v-if="level.hasChildren"
                    static
                    as="dd"
                    class="mt-2 flex flex-col gap-2 pl-6"
                >
                    <div v-if="fetching" class="bg-neutral p-4">
                        <UiLoader />
                    </div>
                    <template v-else-if="children">
                        <FrameworkItem
                            v-for="sublevel in children"
                            :key="sublevel.id"
                            :level="sublevel"
                        />
                    </template>
                </DisclosurePanel>
            </div>
        </Transition>
    </Disclosure>
</template>